import api from "./axios";

export const listConversations = () => api.get("/chat/conversations");
export const chatContacts = () => api.get("/chat/contacts");
export const openDirect = (user_id) => api.post("/chat/conversations/direct", { user_id });
export const getChatMessages = (convId, params = {}) =>
  api.get(`/chat/conversations/${convId}/messages`, { params });
export const sendChatMessage = (convId, body, reply_to_id = null) =>
  api.post(`/chat/conversations/${convId}/messages`, { body, reply_to_id });

// Send with file attachments (multipart). `files` is an array of File objects;
// `body` (caption) and `reply_to_id` are optional.
export const sendChatMessageWithAttachments = (convId, { body = "", reply_to_id = null, files = [] }) => {
  const fd = new FormData();
  if (body) fd.append("body", body);
  if (reply_to_id) fd.append("reply_to_id", reply_to_id);
  files.forEach((f) => fd.append("attachments[]", f));
  return api.post(`/chat/conversations/${convId}/messages`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const editChatMessage = (id, body) => api.patch(`/chat/messages/${id}`, { body });
export const deleteChatMessage = (id) => api.delete(`/chat/messages/${id}`);
export const toggleReaction = (id, emoji) => api.post(`/chat/messages/${id}/reactions`, { emoji });
export const markChatRead = (convId) => api.post(`/chat/conversations/${convId}/read`);
export const muteConversation = (convId) => api.post(`/chat/conversations/${convId}/mute`);
export const chatUnreadCount = () => api.get("/chat/unread-count");
